import React, { Component } from 'react'
import {FormattedMessage, FormattedDate, FormattedTime, injectIntl, FormattedNumber} from "react-intl";
import './questionconversation.scss'
import $ from 'jquery'
import {AppContext} from "@lightspeed-invoicing/core-client/frontend";
import GlobalHelper from "../common/GlobalHelper.jsx";
import FingerprintDetails from "../fingerprint/details.component.jsx";
import LoadingSpinner from "../common/spinner/loading.component.jsx";
import Icon from "../common/icon/icon.component.jsx";
import StandardList from "../common/listing/list.component.jsx";
import Image from "../common/image/image.component.jsx";
import {Settings, SupportedSettings} from "../settings/account/Settings.jsx";
import PriceListingLabel from "../product/pricelistinglabel.component.jsx";
import {Link} from "react-router-dom";
import QuoteStatusBadge from "../quote/status.component.jsx";

class QuestionConversationPanel extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            loading: true,
            session: null,
            selectedProducts: [],
            visits: [],
            cart: [],
        }
        this.updateSelectedProduct = this.updateSelectedProduct.bind(this)
        this.handleOnChange = this.props.onChange || function () {}
        this.handleCloseModal = this.props.closeModal || function () {}
    }

    componentDidMount() {
        this.loadSession()
    }

    loadSession() {
        AppContext.getApiClient().get(`/messenger-sessions/${this.props.sessionId}`).then(session => {
            const integrationKey = session.attributes.integrationKey
            let parentUniqueExternalId = []
            parentUniqueExternalId = parentUniqueExternalId.concat(
                session.attributes.productVisits.map(v => integrationKey + '_' + v.attributes.productParentExternalId)
            )
            parentUniqueExternalId = parentUniqueExternalId.concat(
                session.attributes.cart.map(i => integrationKey + '_' + i.attributes.productParentExternalId)
            )
            const uniqueValue = (value, index, self) => { return self.indexOf(value) === index }
            parentUniqueExternalId = parentUniqueExternalId.filter(uniqueValue)

            if (parentUniqueExternalId.length === 0) {
                this.setState({
                    loading: false,
                    session: session,
                    visits: [],
                    cart: [],
                })
                return
            }
            let postData = {
                keywords: '*',
                objects: ['products'],
                fields: ['title'],
                pageSize: 100,
                activePage: 1,
                sortByField: 'titleSort',
                sortAsc: true,
                filters: {
                    parentUniqueExternalId: parentUniqueExternalId,
                }
            }
            AppContext.getApiClient().post('/listing/search', postData).then(search => {
                const products = search.data
                const findProductsByExternalId = (externalId, parentExternalId) => {
                    return products.filter(p => {
                        let field = 'parentExternalId'
                        let value = parentExternalId
                        if (externalId) {
                            field = 'externalId'
                            value = externalId
                        }
                        const links = p.attributes.externalLinks.filter(l => l.attributes.integrationKey === integrationKey).map(l => l.attributes[field])
                        return links.includes(value)
                    })

                }
                const byVisitDuration = (a, b) => {
                    if (a.attributes.duration > b.attributes.duration){ return -1 }
                    if (a.attributes.duration < b.attributes.duration){ return 1 }
                    return 0
                }
                const cart = session.attributes.cart.map(item => {
                    item.attributes.products = findProductsByExternalId(item.attributes.productExternalId, item.attributes.productParentExternalId)
                    return item
                }).filter(v => v.attributes.products.length > 0)
                const visits = session.attributes.productVisits.map(v => {
                        v.attributes.products = findProductsByExternalId(v.attributes.productExternalId, v.attributes.productParentExternalId)
                        return v
                    }).filter(v => {
                        if (v.attributes.products.length === 0) {
                            return false
                        }
                        const products = v.attributes.products
                        if (cart.filter(item => item.attributes.products[0].id === products[0].id).length > 0) {
                            return false
                        }
                        return true
                     }).sort(byVisitDuration)
                this.setState({
                    loading: false,
                    session: session,
                    visits: visits,
                    cart: cart
                })
            })


        })
    }

    displayTimeSpent(seconds) {
        const date = new Date(seconds * 1000)
        if (seconds < 3600) {
            return date.toISOString().substr(14, 5)
        }
        return date.toISOString().substr(11, 8)
    }

    row(item) {
        const product = item.attributes.products[0]
        const image = product.attributes.images.length > 0 ?
            <Image imageId={product.attributes.images[0].id} size="very-small" /> :
            <Icon value={"image"} style={{ fontSize: '30px' }} />


        const title = []
        title.push(<p key={title.length} className={'m-0'}><strong>{product.attributes.title}</strong></p>)
        if (product.attributes.sku) {
            title.push(<p key={title.length} className={'m-0'}>
                <small>{product.attributes.sku}</small>
            </p>)
        }
        if (Settings.get(SupportedSettings.ShowShortDescriptionInListing)) {
            title.push(<p key={title.length} className={'m-0'}>
                {product.attributes.shortDescription}
            </p>)
        }
        const rows = [
            image,
            title,
            item.type === 'cart-items' ? <div>
                <Icon value={'shopping-cart'} className={'mr-1'} />
                <span>
                    {item.attributes.quantity}
                </span>
            </div> : <div>
                <Icon value={'eye'} className={'mr-1'} />
                <span>
                    {this.displayTimeSpent(item.attributes.duration)}
                </span>
            </div>,
        ]
        return {
            metadata: {
                productId: product.id
            },
            data: rows,
            rowId: product.id + '_' + (item.attributes.quantity || '1'),
        }
    }

    updateSelectedProduct(product, selected) {
        const chunks = product.split('_')
        let productId = chunks[0]
        let quantity = chunks[1]
        let products = []
        if (selected) {
            products = this.addProduct(productId, quantity)
        } else {
            products = this.removeProduct(productId)
        }
        this.handleOnChange(products)
    }

    addProduct(productId, quantity) {
        const products = this.state.selectedProducts
        products.push({
            id: productId,
            quantity: quantity
        })
        this.setState({
            selectedProducts: products
        })
        return products
    }

    removeProduct(productId) {
        const products = this.state.selectedProducts.filter(p => p.id !== productId)
        this.setState({
            selectedProducts: products
        })
        return products
    }

    render() {
        if (this.state.loading) {
            return <div className={'w-100'}>
                <LoadingSpinner />
            </div>
        }

        let rows = []
        if (this.state.cart.length) {
            rows.push({
                className: 'bg-custom-light',
                singleColumn: true,
                data: <h6 className={'mb-0 border-0 pb-0'}>
                    <FormattedMessage
                        id="question.panel.what_they_currently_have_in_cart"
                        defaultMessage="What {firstName} currently has in their cart"
                        values={{
                            firstName: this.state.session.attributes.project.attributes.contact.attributes.firstName,
                        }}
                    />
                </h6>
            })
            rows = rows.concat(this.state.cart.map(item => this.row(item)))
        }
        if (this.state.visits.length) {
            rows.push({
                className: 'bg-custom-light',
                singleColumn: true,
                data: <h6 className={'mb-0 border-0 pb-0'}>
                    <FormattedMessage
                        id="question.panel.what_they_visited"
                        defaultMessage="What {firstName} looked at today"
                        values={{
                            firstName: this.state.session.attributes.project.attributes.contact.attributes.firstName,
                        }}
                    />
                </h6>
            })
            rows = rows.concat(this.state.visits.map(item => this.row(item)))
        }

        const project = this.state.session.attributes.project

        return <div className={'w-100'}>
            <div className={'w-100'}>
                <h6 className={'mb-0'}>
                    <Icon value={'globe-americas'} className={'mr-1'}/>
                    <FormattedMessage
                        id="question.panel.conversation_source"
                        defaultMessage="Source: {host}"
                        values={{
                            host: this.state.session.attributes.host,
                        }}
                    />
                </h6>
            </div>
            <div className={'w-100 mb-3 row py-0 ui-has-modules'}>
                <FingerprintDetails style={'panel'} fingerprintId={this.state.session.attributes.fingerprintId} />
            </div>
            {project.attributes.quotes.length > 0 && <div className={'w-100 mb-3'}>
                <ul className="list-group ui-has-modules w-100 row py-0">
                    {project.attributes.quotes.map(quote => {
                        return <li className="list-group-item py-2" key={quote.id}>
                            <a href={'#'} onClick={e => {
                                e.preventDefault()
                                this.handleCloseModal(quote.id)
                            }}>
                                <Icon value={'quote'} className={'mr-2'}/>
                                {quote.attributes.identifier}
                            </a>
                            <QuoteStatusBadge status={quote.attributes.status} className={'ml-2'} />
                        </li>
                    })}
                </ul>
            </div>}
            <div className={'w-100 mb-2'}>
                <StandardList
                    className="w-100 row py-0"
                    headers={null}
                    smallLine={true}
                    rows={rows}
                    overrideColsCount={3}
                    onRowSelect={this.updateSelectedProduct}
                    selectable={true}
                    totalItemsCount={this.state.totalItemsCount}
                    pageSize={this.state.pageSize}
                />
            </div>
        </div>
    }
}

export default injectIntl(QuestionConversationPanel)





// WEBPACK FOOTER //
// ./src/question-conversation/questionconversationpanel.jsx